import React, { useState } from "react";

import AdminHeader from "../../AdminComponents/AdminHeader/AdminHeader";

import SideBarAdmin from "../../AdminComponents/SideBarAdmin/SideBarAdmin";
// import AddVehicleDrawer from "./AddVehicleDrawer";
// import TableDateAdminVehicle from "./TableDateAdminVehicle";
// import "./VehiclesAdmin.css";
import { useDispatch } from "react-redux";


import { addVehicle } from "../../redux/AdminReducer";
import DriverHeader from "../DiverHeader/DiverHeader";
import SideBarDriver from "../SideBarDriver/SideBarDriver";

const DriverDashboard = () => {
  const [rightHeader, setRightHeader] = useState(false);

  const dispatch=useDispatch();

  return (
    <>
      {/* <AdminHeader rightHeader={rightHeader} /> */}

      <DriverHeader rightHeader={rightHeader}/>

      <div className="topSideVehicles">
        {/* <SideBarAdmin
          setRightHeader={setRightHeader}
          rightHeader={rightHeader}
        /> */}


        <SideBarDriver
           setRightHeader={setRightHeader}
           rightHeader={rightHeader}
        
        />
        <div className="vehicleAdminMain">
          {/* <div className="topTextEditAdmVehic">
            You can see and edit detail about vehicles here..
          </div>

          <div className="topTextsVehiclAdmin">
            <div className="topInputBtnSearch">
              <input placeholder="Search Vehicle" className="inputSearchVehic" />
              <button className="btnSearchVehicle">Search</button>
            </div> */}

            {/* <div  className="topAddVehicleDrawer">
              <AddVehicleDrawer/> */}
              {/* Add vehicle */}
            
            
            {/* </div> */}
          {/* </div> */}
         <div className="topTableAdminVehicles">
         {/* <TableDateAdminVehicle/> */}
         </div>
        </div>
      </div>
      {/* <div style={{marginTop:"100px"}}>
        hfgjhdfg
      </div> */}
    </>
  );
};

export default DriverDashboard;
